import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import UploadDocumentButtonOnboarding from '../../../buttons/UploadDocumentButtonOnboarding';
import useIsMobile from '../../../../hooks/useIsMobile';
import ShoppingCartStepperNavigation from '../../ShoppingCartStepperNavigation';
import ShoppingCartSummaryActionButton from '../../ShoppingCartSummary/ShoppingCartSummaryActionButton';
import { HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME } from '../../../../theme/constants/stack';

const UploadDocumentsStep = ({ prevStep, invoices }) => {
  const allXMLUploaded = useMemo(
    () => invoices.every((invoice) => invoice.hasXMLDocument),
    [invoices],
  );
  const isMobile = useIsMobile();
  return (
    <Box sx={{ width: '100%', px: { xs: 2, md: 8 }, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
      <Grid container sx={{ maxWidth: 500, mb: 1 }} alignItems="center" justifyContent="center">
        <Grid item xs={6}>
          <Typography variant="medium_1" color="gray.A400">Folio</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="medium_1" color="gray.A400">xml</Typography>
        </Grid>
      </Grid>
      <Box sx={{ maxHeight: 240, maxWidth: 500, overflow: 'auto', width: '100%', mb: 2 }}>
        <Grid container direction="column" spacing={2}>
          {invoices?.map((invoice) => (
            <Grid container item key={invoice.folio} alignItems="center" wrap="nowrap">
              <Grid item xs={6}>
                <Typography variant={isMobile ? 'small_3' : 'medium_3'} fontWeight={500}>{invoice.folio}</Typography>
              </Grid>
              <Grid item xs={6}>
                <UploadDocumentButtonOnboarding
                  invoiceId={invoice.id}
                  invoiceDocuments={invoice.documents}
                  documentType="XML"
                  accept=".xml"
                  errorMessage="El xml subido no corresponde a la factura seleccionada"
                  boxProps={{
                    sx: {
                      maxWidth: 200,
                      height: 45,
                    },
                  }}
                  className={HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
      <ShoppingCartStepperNavigation onBack={prevStep}>
        <ShoppingCartSummaryActionButton
          id="confirm-upload-documents-step-button"
          label={(
            <Typography variant="small_3" color="white" fontWeight={600}>
              Continuar
            </Typography>
              )}
          size="small"
          disabled={!allXMLUploaded}
        />
      </ShoppingCartStepperNavigation>
    </Box>
  );
};

UploadDocumentsStep.propTypes = {
  prevStep: PropTypes.func.isRequired,
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      folio: PropTypes.string,
      documents: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          type: PropTypes.shape({
            id: PropTypes.string,
            code: PropTypes.string,
          }),
        }),
      ),
    }),
  ),
};

UploadDocumentsStep.defaultProps = {
  invoices: [],
};

export default UploadDocumentsStep;
